import { apiWrapper, apiCancel } from '../../wrapper'

export const initial = 'pencantumanGelar'
const baseUrl = process.env.REACT_APP_SERVICE_CORE_URL
const appCode = process.env.REACT_APP_SERVICE_CORE_APPCODE
const outputType = 'json'

export const masterEducation = 'Master/Education/list/'
export const masterEducationGroup = 'Master/List/EducationGroup/'
export const employeeList = 'Kepegawaian/PencantumanGelar/listEmployee/'

export const pencantumanGelarCreate = 'Kepegawaian/PencantumanGelar/create/'
export const pencantumanGelarList = 'Kepegawaian/PencantumanGelar/list/'
export const pencantumanGelarDetail = 'Kepegawaian/PencantumanGelar/detail/'
export const pencantumanGelarUpdate = 'Kepegawaian/PencantumanGelar/update/'
export const pencantumanGelarInactive = 'Kepegawaian/PencantumanGelar/inactive/'
export const pencantumanGelarActive = 'Kepegawaian/PencantumanGelar/active/'
export const pencantumanGelarApprove = 'Kepegawaian/PencantumanGelar/approve/'
export const pencantumanGelarExportUsulan = 'Kepegawaian/PencantumanGelar/exportUsulan/'
export const ListJabatan = 'Kepegawaian/PencantumanGelar/listjabatan/'

//export const cancelToken = () => apiCancel
export const cancelToken = () => {
    return apiCancel()
}
export const apiRequest = async (method, route, data = { params: null, body: null, cancelToken: null }, needToken=true) => {
    if(needToken) {
        const thisTime = (Math.floor(Date.now()/1000))
        const expire = localStorage.getItem(initial + 'accessExpired')
        if(expire < thisTime) {
           await apiWrapper(baseUrl, initial, appCode, outputType, 'post', 'auth/getAccessToken/', data)
           .then(result => {
                localStorage.setItem(initial + 'accessToken', result.response.access_token)
                return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
            })
            .catch(result => {
                return Promise.reject('Tidak dapat mengambil accessToken');
            })
        } else {
            return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)        
        }
    }
    return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
}